<template>
  <baseFrame
    save-text=""
    clear-text=""
    :cancel-text="isEdit ? '取消' : ''"
    :submit-text="isEdit ? '提交' : ''"
    :logText="!isEdit ? '操作日志' : ''"
    :submitLoading="submitLoading"
    :infosArr="infosArr"
    :logData="logData"
    @submit="submit"
    @hanldeLog="handleLog"
    @cancel="handleToList">
    <div slot="content">
      <lk-card class="mb16" title="发票信息" v-if="isEdit">
        <lk-form
          label-position="right"
          :label-width="150"
          :rules="formRules"
          :model="formModel"
          ref="form"
        >
          <div>
            <lk-row :gutter="16">
              <lk-col :span="7">
                <lk-form-item label="开票时间:" prop="invoiceTime">
                  <timeStampDatePicker
                    class="item"
                    placeholder=" 请选择"
                    clearable
                    v-model.trim="formModel.invoiceTime">
                  </timeStampDatePicker>
                </lk-form-item>
              </lk-col>
              <lk-col :span="7">
                <lk-form-item label="发票编码:" prop="invoiceCode">
                  <lk-input
                    class="item"
                    clearable
                    placeholder=""
                    v-model.trim="formModel.invoiceCode"
                    :maxlength="500">
                  </lk-input>
                </lk-form-item>
              </lk-col>
            </lk-row>
          </div>
        </lk-form>
      </lk-card>
      <lk-card class="mb16" title="预付款列表">
        <div class="mb8">当前剩余可用：{{tableData.availablePrepaymentAmount}}</div>
        <lk-table border :columns="columns" :data="tableData"></lk-table>
      </lk-card>
    </div>
  </baseFrame>
</template>
<script>
import utils from '../../libs/utils';
import mapState from '../../mixins/mapState'; // 鉴权
import finance from '../../services/finance';
import sale from '../../services/sale';
import baseFrame from '../../components/frame/BaseFrame.vue';

export default {
  name: 'prePaymentForm',
  mixins: [mapState],
  components: {
    baseFrame,
  },
  data() {
    return {
      infosArr: [],
      logData: [],
      formModel: {
        invoiceTime: null,
        invoiceCode: null,
      },
      formRules: {},
      submitLoading: false,
      columns: [
        { title: '预付单ID', key: 'id', minWidth: 116 },
        { title: '供应商名称', key: 'supplierName', minWidth: 116 },
        { title: '预付金额（元）', key: 'preAmount', minWidth: 116 },
        { title: '本期使用（元）', key: 'amount', minWidth: 116 },
        { title: '创建时间', key: 'createTime', minWidth: 116 },
        { title: '状态', key: 'statusName', minWidth: 116 },
        {
          title: '应付单号',
          key: 'payableCodes',
          minWidth: 116,
        },
        {
          title: '付款单号',
          key: 'paymentCode',
          minWidth: 116,
          render: (h, { row }) => {
            const self = this;
            return h('a', {
              on: {
                click() {
                  self.$router.push({
                    name: 'paymentCheck',
                    params: {
                      id: row.paymentId,
                    },
                  });
                },
              },
            }, row.paymentCode);
          },
        },
      ],
      tableData: [],
    };
  },
  computed: {
    isEdit() {
      return this.$route.name === 'prePaymentEdit';
    },
  },
  methods: {
    getDetails(id) {
      finance.getPrePaymentInfo({ financePrepaymentId: id }).then((res) => {
        if (res.data.status === 200) {
          // this.tableData = res.data.data;
          const data = res.data.data;
          const infoData = Object.assign(data, data.financePrepayment);

          this.tableData.availablePrepaymentAmount = data.availablePrepaymentAmount; // 当前剩余可用
          delete infoData.financePrepayment;

          data.financePaymentRecordVoList && data.financePaymentRecordVoList.forEach((item) => {
            const result = Object.assign(item, item.financePaymentRecord);
            result.createTime = utils.formatDate(result.createTime);
            result.supplierName = infoData.supplierName;
            result.preAmount = infoData.amount;
            this.tableData.push(result);
          });

          if (this.isEdit) {
            this.formModel = infoData;
          }
          this.setInfoList(infoData);
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    setInfoList(data) {
      this.infosArr.push({
        name: '门店:',
        value: data.storeName,
      }, {
        name: '供应商编码:',
        value: data.supplierCode,
      }, {
        name: '供应商名称:',
        value: data.supplierName,
      }, {
        name: '付款时间:',
        value: utils.formatDate(data.payTime),
      }, {
        name: '付款金额:',
        value: data.amount,
      }, {
        name: '创建人:',
        value: data.createUserName,
      }, {
        name: '创建时间:',
        value: utils.formatTime(data.createTime),
      });

      // 编辑的时候 页头不展示
      if (!this.isEdit) {
        this.infosArr.push({
          name: '开票时间:',
          value: utils.formatDate(data.invoiceTime),
        }, {
          name: '发票编码:',
          value: data.invoiceCode,
        });
      }
    },
    submit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.submitLoading = true;
          const params = {
            financePrepayment: this.formModel,
          };
          finance.prePaymentEdit(params).then((res) => {
            if (res.data.status === 200) {
              this.$Message.success('提交成功');
              this.handleToList();
            } else {
              this.$Message.error(res.data.error);
            }
            this.submitLoading = false;
          }).catch((err) => {
            this.submitLoading = false;
            utils.handleError(err);
          });
        } else {
          this.$Message.error(' 请按照要求填写');
        }
      });
    },
    handleLog() {
      this.logData = [];
      sale.getEditLog({
        bizType: 2,
        bizId: this.$route.params.id,
      }).then((res) => {
        if (res.data.status === 200) {
          this.logData = res.data.data;
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    handleToList() {
      this.$router.push({
        name: 'prePaymentList',
      });
    },
  },
  created() {
    const id = this.$route.params.id;
    if (id) {
      this.getDetails(id);
    }
  },
};
</script>
<style lang="less" scoped>
</style>
